/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component } from 'react' // eslint-disable-line
import { Tag } from 'antd'

export default (props: any) => {
  let userState = props['config']['0']
  let item = props['item']
  let status = props['status']

  if (props['config'][`${status}`]) {
    userState = props['config'][`${status}`]
  }
  return <Tag color={userState.color} key={item.id}>
    {userState.text}
  </Tag>
}